
import axios from 'axios';
import { ElMessage } from 'element-plus'
import { clearUserInfo, getUserToken } from '@/utils/userinfo'
axios.defaults.timeout = 30000;//最长等待时间

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    const token = getUserToken();
    if (token) {
        config.headers["token"] = token;
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) { // 添加响应拦截器
    if (response.data.code == '1') {
        if (response.data.msg == '成功') {
            return response;
        }
        ElMessage({
            message: response.data.msg,
            type: 'success',
        })
    }
    if (response.data.code == '0') {
        ElMessage({
            message: response.data.msg,
            type: 'warning',
        })
        return Promise.reject(response.data);
    }
    return response;

}, function (err) {
    // 处理HTTP状态码401的情况
    if (err.response && err.response.status === 401) {
        clearUserInfo()
        location.reload()
        return Promise.reject({
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data
        });
    }
    // 其他错误情况
    return Promise.reject(err);
});

export function apiGet(url: string) {
    return new Promise((resolve, reject) => {
        axios({
            method: "get",
            url: url
        })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}


export function apiPost(url: string, data: object) {
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: url,
            data
        })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}

export function postFiles(url: string, data: object) {
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data,
        })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}